import React from "react"
import { StaticQuery, Link, graphql } from "gatsby"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { Row, Col } from "react-bootstrap"
import ScrollAnimation from "react-animate-on-scroll"
import PwaImg from "../../images/pwa.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons"
import MobileFirstPageStyle from "./mobile-first-page.module.scss"

const MobileFirstSec2 = () => (
    <StaticQuery query={graphql`
        query MobileFirstSec2{
            contentfulMobileFirstPage{
                mobileFirstReference{
                  sectionContent4{
                    subtitle{
                      subtitle
                    }
                    sectionParagraph{
                      json
                    }
                  }
                }
              }
            }
        `}
    render={data => (
    <div className={MobileFirstPageStyle.sectionDiv}>
        <Row>
            <Col className={MobileFirstPageStyle.mobileFirstSec2Col1} md={4} sm={6}>
                <ScrollAnimation animateIn="fadeInUp" duration={2} animateOnce={true}>
                    <PwaImg className={MobileFirstPageStyle.pwaImg} />
                </ScrollAnimation>
            </Col>
            {/* Section 4 Content */}
            <Col className={MobileFirstPageStyle.mobileFirstSec2Col2} md={8} sm={6}>
                <h3 className={MobileFirstPageStyle.sectionTitleLeftAlign}>{data.contentfulMobileFirstPage.mobileFirstReference.sectionContent4.subtitle.subtitle}</h3>
                <div className={MobileFirstPageStyle.sectionDescriptionLeftAlign}>
                    {documentToReactComponents(data.contentfulMobileFirstPage.mobileFirstReference.sectionContent4.sectionParagraph.json)}
                </div>
            </Col>
        </Row>
        <Row className={MobileFirstPageStyle.mobileFirstLinksRow1}>
            <Col className={MobileFirstPageStyle.mobileFirstLinksCol} md={12}>
                <Link to="/essentials" className={MobileFirstPageStyle.mobileFirstLinks}>The Essentials</Link>
                <span className={MobileFirstPageStyle.activeLink}>Mobile First</span>
                <Link to="/engaging-menu" className={MobileFirstPageStyle.mobileFirstLinks}>Engaging Menu</Link>
                <Link to="/convenient-booking" className={MobileFirstPageStyle.mobileFirstLinks}>Convenient Booking</Link>
            </Col>
        </Row>
        <Row className={MobileFirstPageStyle.mobileFirstLinksRow2}>
        <Col className={MobileFirstPageStyle.mobileFirstLinksMobileCol} xs={6}>
                <Link to="/essentials" className={MobileFirstPageStyle.mobileFirstLinksMobile}><FontAwesomeIcon icon={faArrowLeft} className={MobileFirstPageStyle.chevronIcons} /> Previous</Link>
            </Col>
            <Col className={MobileFirstPageStyle.mobileFirstLinksMobileCol} xs={6}>
                <Link to="/engaging-menu" className={MobileFirstPageStyle.mobileFirstLinksMobile}>Next <FontAwesomeIcon icon={faArrowRight} className={MobileFirstPageStyle.chevronIcons} /></Link>
            </Col>
        </Row>
    </div>
    )}
    />
)

export default MobileFirstSec2